module.exports = __webpack_public_path__ + "media/assets/fonts/RobotoCondensed-Bold-c5fe6deebafaec078e64904b81f9ae60.ttf";